import { useSelector, useDispatch } from "react-redux";

export function useGenericPreference<T>({ get, set, del }, name: T) {
  const currentVal = useSelector((state) => get(state, name));
  const dispatch = useDispatch();

  function setVal(val) {
    dispatch(set(name, val));
  }

  function removeVal() {
    dispatch(del(name));
  }

  return {
    currentVal,
    setVal,
    removeVal,
  };
}
